export class ObjectMapper {
    public static copyProperties(source: any, destination: any, excludedProperties: any[] = []) {
        for (var property in source) {
            if (!excludedProperties || excludedProperties.indexOf(property) == -1) {
                destination[property] = source[property];
            }
        }
    }

    public static clone(source: any): any {
        return Object.assign({}, source);
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/common/object-mapper.ts